<template lang="pug">
div
  v-sheet.pa-4(:class="showDetails ? 'secondary' : 'primary'")
    .d-flex
      v-btn.mr-3(fab, icon small, v-if="isMovil || !isMovil && showDetails", @click="showDetails ? closeOpciones() : close()")
        v-icon(:color="showDetails ? 'primary' : 'white'" size="25") arrow_back
      v-text-field(
        v-if="!showDetails"
        v-model='search'
        @input="buscarValor"
        dense
        label='Buscar en configuraciones'
        dark=''
        flat=''
        solo-inverted=''
        hide-details=''
        clearable=''
        clear-icon='close'
      )
      .d-flex.flex-1.ai-center(v-else)
        span.primary--text.font-weight-700.font-size-20 {{showOptions.titulo}}
        v-spacer
        //- v-btn(color="primary white--text" icon small, @click="fetchGuardarConfiguraciones")
        //-   v-icon more_vert
  v-alert(prominent='' type='warning'  v-if="showAlertReload")
    .d-flex.jc-center.ai-center
      .d-flex.fd-column
        small Al realizar cualquier cambio en las configuraciones de la aplicacion es recomendable presionar F5 o darle click en el siguiente boton
        v-btn.mt-3(color="white warning--text" small @click="reloadPage()") Actualizar pagina
      v-btn(small icon @click="closeAlertReload()")
        v-icon cancel
  .box-settings(:class="showAlertReload ? 'reload' : ''")
    v-list.py-0(dense flat two-line='', v-if="configuraciones.length && !showDetails")
      v-list-item( v-for="(c, index) in configuraciones" :key="index" @click="openOpciones(c)")
        v-list-item-avatar
          v-icon.background
            | {{c.icon}}
        v-list-item-content
          v-list-item-title {{c.titulo}}
          v-list-item-subtitle {{c.subtitulo}}
        v-list-item-action
          v-btn(icon='')
            v-icon  chevron_right
      v-list-item
        v-list-item-content
          theme-provider
    v-list.py-0(dense flat='' two-line='')
      v-list-item(v-if="showDetails && showOptions.key === 'general'")
        v-list-item-content.py-6
          v-list-item-title Habilitar Modo Oscuro
          v-list-item-subtitle.font-size-12 Alarga la duración de la batería, Reduce la fatiga visual, Ayuda a la lectura etc.
        v-list-item-action
          v-switch(v-model='isDark' dense)
    v-card.elevation-0(v-if="search && !configuraciones.length ")
      v-alert(text='' dense  type='error' icon='settings')
        small Ninguna coincidencia para esta busqueda
  .d-flex.mx-4.my-2
    v-btn(color="success" dark block :small="!isMovil", @click="fetchGuardarConfiguraciones")
      | Guardar configuraciones
</template>
<script>
import { apiPost, notify } from '../util/general'
import themeProvider from './c_theme_changer'
export default {
  components: {
    'theme-provider': themeProvider
  },
  data () {
    return {
      search         : '',
      filtered       : [],
      configuraciones: [
        {
          titulo   : 'General',
          subtitulo: 'Cambia el tema, parametros y demas',
          icon     : 'settings',
          key      : 'general'
        }
      ],
      showDetails    : false,
      isModalReload  : false,
      showOptions    : {},
      showAlertReload: false,
      isDark         : false
    }
  },
  created () {
    var vm = this
    vm.filtered = vm.configuraciones
  },
  computed : {
    isMovil () {
      var vm = this
      return vm.$vuetify.breakpoint.smAndDown
    },
    settings () {
      var vm = this
      return vm.$store.state.app.settings
    }
  },
  mounted () {
    var vm = this
    vm.getConfigs()
  },
  watch : {
    settings : function (val) {
      var vm = this
      vm.getConfigs()
    }
  },
  methods : {
    getConfigs () {
      var vm = this
      vm.isDark  = vm.settings.general.theme.dark
    },
    reloadPage () {
      window.location.reload(true)
    },
    closeAlertReload () {
      var vm = this
      vm.showAlertReload = false
    },
    fetchGuardarConfiguraciones () {
      var vm = this
      vm.showAlertReload = false
      var settingsObj = {
        general : {
          theme : {
            name : 'datacont',
            dark : vm.isDark
          }
        }
      }
      var obj = {
        configuraciones: settingsObj
      }
      apiPost(vm, 'usuario/actualizar/configuracion/app', obj, function (data) {
        notify(vm, 'success', 'Exito', 'Los cambios se guardarón exitosamente')
        var configs            = data.configuraciones
        vm.$store.dispatch('setSettings', configs)
        vm.$vuetify.theme.dark = configs.general.theme.dark
        vm.showAlertReload     = true
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
      })
    },
    openOpciones (c) {
      var vm = this
      vm.showOptions = c
      vm.showDetails = true
    },
    closeOpciones () {
      var vm = this
      vm.keyOption = {}
      vm.showDetails = false
    },
    close () {
      var vm = this
      vm.closeOpciones()
      vm.$emit('close')
    },
    buscarValor (value) {
      var vm = this
      if (value) {
        vm.configuraciones = vm.filtered
        vm.configuraciones = vm.configuraciones.filter(e => {
          return e.titulo.toLowerCase().includes(value.toLowerCase()) || e.subtitulo.toLowerCase().includes(value.toLowerCase())
        })
      } else vm.configuraciones = vm.filtered
    }
  }
}
</script>
<style lang="stylus" scoped>
.box-settings
  height: calc(100vh - 120px);
  overflow-y: auto;
.reload
  height calc(100vh - 273px) !important
</style>



// WEBPACK FOOTER //
// c_configuraciones_app.vue?9000182a